import { render } from "./NewsletterForm.vue?vue&type=template&id=a80f9a78"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/NewsletterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a80f9a78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a80f9a78', __exports__)) {
    api.reload('a80f9a78', __exports__)
  }
  
  module.hot.accept("./NewsletterForm.vue?vue&type=template&id=a80f9a78", () => {
    api.rerender('a80f9a78', render)
  })

}


export default __exports__